module.exports = __webpack_public_path__ + "static/media/Apple Watch 42mm Silver Aluminum + Ocean Blue Open.afb0bc6a.png";